var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8025 6.9105L15.147 4.68162V0.921124C15.147 0.752445 15.0123 0.614943 14.8487 0.614943L12.4859 0.614143C12.3215 0.614143 12.1876 0.752444 12.1876 0.920325V2.19781L10.0163 0.375927C9.419 -0.125309 8.58028 -0.125309 7.983 0.375927L4.01745 3.70481L0.197633 6.9105C0.019296 7.05999 -0.0453518 7.29822 0.0325338 7.52047C0.109632 7.7435 0.305882 7.885 0.536387 7.885H2.10482V15.7537C2.10482 16.4388 2.65074 17 3.31813 17H14.6811C15.3485 17 15.8944 16.4396 15.8944 15.7537L15.8952 7.88582H17.4636C17.6941 7.88582 17.8904 7.74352 17.9675 7.52129C18.0453 7.29826 17.9807 7.06082 17.8024 6.91052L17.8025 6.9105Z",
    fill: "#6141A5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.1c7d93e9a860d1eb9626f114470c118f.svg";
export { ForwardRef as ReactComponent };